import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { H3, Button } from "@animech/ui";
import { useTranslation } from "react-i18next";
import * as Styled from "./error.style";
export var ErrorPanel = function () {
    var t = useTranslation().t;
    return (_jsx(Styled.ErrorPanel, { children: _jsxs("div", { className: "".concat(Styled.prefix, "-content"), children: [_jsxs(H3, { children: [" ", t("error_page.title"), " "] }), _jsx("div", { className: "".concat(Styled.prefix, "-message"), children: t("error_page.message") }), _jsx(Button, { onClick: function () { return window.location.reload(); }, children: t("error_page.reload_page_button") })] }) }));
};
